var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnAbrechnungSelbst(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2 82.5h80M67.118 28.91v15.906a1.7 1.7 0 0 1-1.7 1.7H42.745a1.7 1.7 0 0 1-1.7-1.7V28.91a1.7 1.7 0 0 1 1.7-1.7h22.673a1.7 1.7 0 0 1 1.7 1.7zM71.586 53.36v6.226H10.64V53.36zM41.045 40.232h26.073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h84v84H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m51.129 46.516-1.52 5.203M57.399 46.516l1.52 5.203M19.794 29.504l-4.063 4.4v18.488M18.8 26.142l1.856 1.856c.394.387.625.91.643 1.462l.19 3.99 2.47 2.47 3.844-3.932 3.917-3.873-2.5-2.47-3.975-.146a2.236 2.236 0 0 1-1.461-.643L21.914 23 18.8 26.142z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.73 46.516h6.52a2.923 2.923 0 0 1 2.995 2.923v2.923M15.731 82.082V60.115M67.118 82.082V60.115M60.732 82.082v-15.2M22.001 81.082v-15.2M15.731 65.882h51.387",
    stroke: "#000",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnAbrechnungSelbst);
export default __webpack_public_path__ + "static/media/icn-abrechnung-selbst.a182158520fc2689baff0c1238551af0.svg";
export { ForwardRef as ReactComponent };